import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { formatIndianPrice } from "../../formatIndianPrice";

const COLORS = ["#fe8d5c", "#270b79"]; // Light Blue and Light Pink

const ReactDonutChart = ({ data }) => {
  if (
    !data ||
    !data.chart ||
    !data.chart.data ||
    !data.chart.data.labels ||
    !data.chart.data.datasets
  ) {
    return <div className="d-flex justify-content-center align-items-center" style={{height:'100%',fontWeight:'500',fontSize:'24px',color:'#391f84'}}>No Data Found</div>;
  }

  const chartLabels = data.chart.data.labels;
  const chartValues = data.chart.data.datasets[0].values;

  const chartData = chartLabels.map((label, index) => ({
    name: label,
    value: chartValues[index],
  }));

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "6px",
          padding: "8px 12px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          fontSize: "12px",
        }}
      >
        <p style={{ margin: 0, fontWeight: "bold", color: "#391f84" }}>
          {payload[0].name}
        </p>
        <p style={{ margin: 0, color: "#823455" }}>
          {payload[0].value}
        </p>
      </div>
    );
  }
  return null;
};


  return (
    <div style={{ width: "100%", height: 300 }}>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={chartData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={90}
            outerRadius={120}
            paddingAngle={0}
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
         <Legend
  verticalAlign="bottom"
  formatter={(value) => (
    <span style={{ color: "#391f84", fontSize: 13 }}>{value}</span>
  )}
/>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ReactDonutChart;
